import { render, staticRenderFns } from "./newTable.vue?vue&type=template&id=3eada5a0&scoped=true"
import script from "./newTable.vue?vue&type=script&lang=js"
export * from "./newTable.vue?vue&type=script&lang=js"
import style0 from "./newTable.vue?vue&type=style&index=0&id=3eada5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eada5a0",
  null
  
)

export default component.exports